import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSellfyComponent } from './simple-icons-sellfy.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSellfyComponent ],
    exports:      [ SimpleIconsSellfyComponent ],
    bootstrap:    []
})
export class SimpleIconsSellfyModule {}
